<template>
  <v-autocomplete
    v-model="model"
    v-bind="attrBind"
    :clearable="!disabled && !required"
    :itemText="itemText"
    :items="items"
    :loading="isLoading"
    :placeholder="placeholder"
    :search-input.sync="search"
    v-on="$listeners"
    @click:clear="clear"
  >
    <template #no-data>
      <v-list-item>
        <v-list-item-title v-if="isLoading"> Đang tìm kiếm </v-list-item-title>
        <v-list-item-title v-else>
          Không có dữ liệu thỏa mãn
        </v-list-item-title>
      </v-list-item>
    </template>
    <template #append-item>
      <div v-if="!noPaginate && !isLoading">
        <div v-intersect="onIntersect"></div>
      </div>
    </template>
    <template #item="{item}">
      <slot :item="item" name="item">
        <v-list-item-content>
          {{ item[itemText] }}
        </v-list-item-content>
      </slot>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from '@utils'
import sdk from '@src/service/auth-sdk'
import FieldMixin from './field-mixin'
export default {
  mixins: [FieldMixin],
  props: {
    convertData: { type: Function },
    url: { type: String, required: true },
    noPaginate: Boolean,
    paramSearch: {
      type: String,
      default: 'search',
    },
    params: { type: Object, default: () => ({}) },
    reCallWhenChangeSearch: Boolean,
    customItem: Boolean,
    placeholder: { type: String, default: 'Nhập để tìm kiếm' },
    itemText: { type: String, default: 'name' },
    perpage: {
      type: [String, Number],
      default: 5,
    },
    disabled: Boolean,
  },
  data: () => ({
    items: [],
    isLoading: false,
    search: null,
    paginate: {},
    p_model: null,
  }),

  computed: {
    model: {
      get() {
        return this.value || this.p_model
      },
      set(value) {
        this.p_model = value
        this.$emit('input', value)
        this.$emit('select:item', value)
      },
    },
  },
  created() {
    if (!this.disabled && this.noPaginate) this.getData()
  },
  watch: {
    value: {
      handler(value) {
        if (!value) {
          this.search = null
          this.p_model = null
        } else {
          if (typeof value == 'object') {
            this.p_model = value
            if (this.items.length < 1) this.items = [value]
          }
        }
      },
      immediate: true,
    },
    search: debounce(function(newVal) {
      if (!newVal) return
      this.getData(newVal)
    }, 200),
    params: {
      handler: debounce(function(newVal) {
        if (!newVal) return
        this.getData(this.search)
      }, 200),
      deep: true,
    },
  },
  methods: {
    onIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.loadMore()
      }
    },
    loadMore() {
      if (
        !this.isLoading &&
        this.paginate.total > this.paginate.page * this.paginate.perpage
      ) {
        this.getData(this.search, this.paginate.page + 1)
      }
    },
    async getData(newVal, page = 1) {
      if (!this.url) return
      if (this.disabled && this.items.length > 0) return
      if (this.p_model && this.p_model[this.itemText] === newVal) return
      if (this.isLoading) return
      if (
        this.noPaginate &&
        !this.reCallWhenChangeSearch &&
        this.items &&
        this.items.length > 0
      )
        return
      try {
        this.isLoading = true
        this.paginate.page = page
        const params = this.noPaginate
          ? { limit: this.perpage, paginate: false }
          : { perpage: this.perpage, paginate: true, page }
        let res = await sdk.get(
          this.url,
          {
            params: { ...this.params, ...params, [this.paramSearch]: newVal },
          },
          {}
        )
        let items = []
        let pagination = { total: 0, perpage: 5, page: 1 }
        if (this.convertData) {
          let data = this.convertData(res)
          items = data.items
          pagination = data.pagination
        } else {
          res = res.data
          if (res.message) {
            res = res.data
          }
          if (this.noPaginate) {
            items = res || []
          } else {
            if (res && res.data) {
              items = res.data
            }
          }
        }
        this.paginate = pagination
        if (parseInt(this.paginate.page) == 1) {
          this.items = items
        } else {
          this.items = this.items.concat(items)
        }
      } finally {
        this.$nextTick(() => {
          this.isLoading = false
        })
      }
    },
    clear() {
      this.model = undefined
      this.$emit('click:clear')
      this.getData()
    },
  },
}
</script>

<style scoped></style>
